<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing" v-if="consent">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <h5 class="fw-medium text-black-emphasis mb-20">
        {{ $t('feature.consent.version_history') }}
      </h5>
      <div class="version-list">
          <div  v-for="version in versions" :key="version.revision_number" class="d-flex align-items-center justify-content-between py-2 border-bottom border-light-subtle" @click="show(version as ConsentVersion)"
            :class="[{ 'opacity-50': version.published_at === undefined, 'cursor-pointer': version.published_at !== undefined}]">
            <span class="d-block fs-md-15 text-black fw-medium">
              {{ version.revision_number }}
            </span>
            <span class="d-block text-paragraph text-uppercase small">
              {{ version.published_at !== undefined ? formatDate(version.published_at) : $t('feature.consent.draft') }}
            </span>
          </div>
      </div>
    </div>
  </div>
</template>
    
<script lang="ts">
import { defineComponent } from "vue";
import { Consent, ConsentVersion } from "@/utils/models/consent.model";
import DateFormatUtils from "@/utils/methods/date_formats";
import dayjs from "dayjs";


export default defineComponent({
  name: "ConsentVersionsList",
  data: function () {
    return {
      consent: this.$route.meta.consent as Consent | undefined,
      versions: [{
        revision_number: '2.0',
      }, {
        revision_number: '1.0',
        published_at: Date.now(),
      }, {
        revision_number: '0.9',
        published_at: dayjs().subtract(1, 'day'),
      }, {
        revision_number: '0.8',
        published_at: dayjs().subtract(3, 'day'),
      }]
    } as unknown as {
      consent?: Consent,
      versions: {
        revision_number: string,
        published_at?: Date
      }[]
    }
  },
  methods: {
    formatDate(date: Date) {
      return DateFormatUtils.YYYYMMDD(date);
    },
    show(version?: ConsentVersion) {
      if(version?.published_at === undefined) return;
      this.$router.push(`/consent/10/version/23`);
    }
  }
});
</script>